module.exports = __webpack_public_path__ + "2ad12e328bb65767898c406b70dd6951.svg";